import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiSimulateResponse = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("gamemode", data.gamemode);
    form.append("optionSelected", data.optionSelected);
    form.append("questionID", data.questionID);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append('detail', data.questionID);
        form.append('detailvar', 'questionID');
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    if (typeof data.deckID !== 'undefined') { 
        form.append("deckID", data.deckID);
    }

    if (typeof data.instance) {
        form.append("instance", data.instance)
    }
    
    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "putResponse"
            },
            data: form
        });
        
        return response.data[0];
    } catch (error) {
        throw error;
    }
}

export const apiPutResponse = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("gamemode", data.gamemode);
    form.append("optionSelected", data.optionSelected);
    form.append("questionID", data.questionID);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);
    
    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append('detail', data.questionID);
        form.append('detailvar', 'questionID');
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
    }

    if (typeof data.deckID !== 'undefined') { 
        form.append("deckID", data.deckID);
    }

    if (typeof data.year === 'number' && data.year !== null && data.year > 2012 ) { 
        form.append("year", data.year);
    }

    if (typeof data.instance) {
        form.append("instance", data.instance)
    }
    
    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "putResponse"
            },
            data: form
        });
        
        return response.data[0];
    } catch (error) {
        throw error;
    }
};


